
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import {SiteNewsRequestType} from "./news.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";

@Component
export default class SiteNewsForm extends Form {

    @Validate(required, i18nText("Введите назавание категории"))
    name: string | null = null;
    preview_text: string | null = null;
    image: Record<string, string> = {};
    image_file: File | null = null;

    getFormData(): SiteNewsRequestType {
        return {
            name: this.name,
            preview_text: this.preview_text,
            image: this.image,
            image_file: this.image_file,
        }
    }

    setFormData(): void {
    }
}
